import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EventKpiCardComponent } from '@shared/components/event-kpi-card/event-kpi-card.component';
import { EVENT_ANALYTICS_KPI_SECTION_ORDER, EVENT_ANALYTICS_KPI_TAB_CARDS } from '../admin-event-analytics.constants';
import { AdminEventAnalyticsStore } from '../admin-event-analytics.store';
import { IKpiCard, IKpiSection } from './admin-event-analytics-kpis.interface';

@Component({
  imports: [EventKpiCardComponent, TranslateModule],
  selector: 'app-admin-event-analytics-kpis',
  styleUrl: './admin-event-analytics-kpis.component.scss',
  templateUrl: './admin-event-analytics-kpis.component.html',
})
export class AdminEventAnalyticsKpisComponent {
  public readonly store = inject(AdminEventAnalyticsStore);

  public readonly sections = computed<IKpiSection[]>(() => {
    const kpis = this.store.kpis$();
    const compareKpis = this.store.compareKpis$();

    return EVENT_ANALYTICS_KPI_SECTION_ORDER.map(
      (section): IKpiSection => ({
        cards: EVENT_ANALYTICS_KPI_TAB_CARDS.filter((config) => config.section === section).map(
          (config): IKpiCard => ({
            comparedCurrentValue: kpis && compareKpis ? config.getValue(compareKpis) : null,
            config,
            currentValue: kpis ? config.getValue(kpis) : null,
            totalValue: kpis && config.getTotal ? config.getTotal(kpis) : null,
          }),
        ),
        section,
      }),
    );
  });
}
